import { Component } from '@angular/core';

@Component({
  selector: 'cd-chatdigest-ui',
  imports: [],
  templateUrl: './chatdigest-ui.html',
  styleUrl: './chatdigest-ui.scss',
})
export class ChatdigestUi {}
